import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum PeopleFilterFields {
  id = 'id',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  fullName = 'fullName',
  textSearch = 'textSearch', //full test search is fullName, email, and externalSystemId - all saved as tolowercase and unaccented in the database to allow for easier searching
  email = 'email',
  status = 'status',
  rating = 'rating',
  gender = 'gender',
  city = 'city',
  state = 'state',
  province = 'province',
  country = 'country',
  county = 'county',
  linkedInProfile = 'linkedInProfile',
  streetAddress1 = 'streetAddress1',
  streetAddress2 = 'streetAddress2',
  postalCode = 'postalCode',
  phoneNumber = 'phoneNumber',
  jobTitle = 'jobTitle',
  company = 'company',
  activeTeamsCount = 'activeTeamsCount',
  allTeamsCount = 'allTeamsCount',
  updatedBy = 'updatedBy',
  updatedOn = 'updatedOn',
  createdBy = 'createdBy',
  createdOn = 'createdOn',
  tags = 'tags',
  notes = 'notes',
  customFields = 'customFields',
  complexCustomFields = 'complexCustomFields',
  teams = 'teams',
  applications = 'applications',
  certifications = 'certifications',
  activeCertifications = 'activeCertifications',
  races = 'races',
  teamExperienceFields = 'teamExperienceFields',
  candidateId = 'candidateId',
  imageId = 'imageId',
  evaluationAggregates = 'evaluationAggregates',
  workspaces = 'workspaces',
  externalSystemId = 'externalSystemId',
  allTeamSummary = 'allTeamSummary',
  activeTeamSummary = 'activeTeamSummary',
  isUnsubscribed = 'isUnsubscribed',
  credentials = 'credentials',
  phoneNumberSearch = 'phoneNumberSearch'
}

export enum PersonCustomFieldFields {
  id = 'id',
  itemId = 'itemId',
  name = 'name',
  value = 'value',
  featured = 'featured',
  uiType = 'uiType',
  updatedOn = 'updatedOn',
  dateRangeAttributeStartDateValue = 'dateRangeAttributeStartDateValue',
  dateRangeAttributeEndDateValue = 'dateRangeAttributeEndDateValue'
}
export enum PersonApplicationFilterFields {
  formId = 'formId',
  title = 'title',
  isUsed = 'isUsed',
  updatedOn = 'updatedOn',
  submissionDate = 'submissionDate',
  sentDate = 'sentDate',
  source = 'source',
  workspaceId = 'workspaceId'
}

export enum PersonCertificationFilterFields {
  certificationId = 'certificationId',
  name = 'name',
  number = 'number',
  url = 'url',
  activeDate = 'activeDate',
  expirationDate = 'expirationDate'
}

export enum PersonRaceFilterFields {
  id = 'id',
  name = 'name'
}

export enum PersonTagFilterFields {
  id = 'id',
  text = 'text'
}

export enum PersonNotesFilterFields {
  id = 'id',
  description = 'description'
}

export enum PersonTeamFilterFields {
  id = 'id',
  name = 'name',
  status = 'status',
  positionStatus = 'positionStatus',
  positionTitle = 'positionTitle',
  teamStartDate = 'startDate',
  teamEndDate = 'endDate',
  customFields = 'customFields',
  trackedCustomFields = 'trackedCustomFields',
  seatStartDate = 'seatStartDate',
  seatEndDate = 'seatEndDate'
}

export enum PersonEvaluationAggregateFilterFields {
  id = 'id',
  questionId = 'questionId',
  questionName = 'questionName',
  questionType = 'questionType',
  questionItemId = 'questionItemId',
  questionItemName = 'questionItemName',
  aggregateResponseValue = 'aggregateResponseValue'
}

export const PeopleSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(PeopleFilterFields.id, '', 'ID'),
  new ItemPickerModel(PeopleFilterFields.firstName, '', 'First Name'),
  new ItemPickerModel(PeopleFilterFields.middleName, '', 'Middle Name'),
  new ItemPickerModel(PeopleFilterFields.lastName, '', 'Last Name'),
  new ItemPickerModel(PeopleFilterFields.fullName, '', 'Name'),
  new ItemPickerModel(PeopleFilterFields.email, '', 'Email'),
  new ItemPickerModel(PeopleFilterFields.externalSystemId, '', 'External System Id'),
  new ItemPickerModel(PeopleFilterFields.isUnsubscribed, '', 'Email Preference'),
  new ItemPickerModel(PeopleFilterFields.phoneNumberSearch, '', 'Phone Number'),
  new ItemPickerModel(PeopleFilterFields.status, '', 'Profile Status'),
  new ItemPickerModel(PeopleFilterFields.jobTitle, '', 'Job Title'),
  new ItemPickerModel(PeopleFilterFields.company, '', 'Company'),
  new ItemPickerModel(PeopleFilterFields.linkedInProfile, '', 'LinkedIn Profile'),
  new ItemPickerModel(PeopleFilterFields.gender, '', 'Gender'),
  new ItemPickerModel(PeopleFilterFields.races, '', 'Race'),
  new ItemPickerModel(PeopleFilterFields.streetAddress1, '', 'Street Address 1'),
  new ItemPickerModel(PeopleFilterFields.streetAddress2, '', 'Street Address 2'),
  new ItemPickerModel(PeopleFilterFields.city, '', 'City'),
  new ItemPickerModel(PeopleFilterFields.state, '', 'State'),
  new ItemPickerModel(PeopleFilterFields.province, '', 'Province'),
  new ItemPickerModel(PeopleFilterFields.postalCode, '', 'Postal Code'),
  new ItemPickerModel(PeopleFilterFields.county, '', 'County'),
  new ItemPickerModel(PeopleFilterFields.country, '', 'Country'),
  new ItemPickerModel(PeopleFilterFields.rating, '', 'Rating'),
  new ItemPickerModel(PeopleFilterFields.updatedBy, '', 'Updated By'),
  new ItemPickerModel(PeopleFilterFields.updatedOn, '', 'Updated On'),
  new ItemPickerModel(PeopleFilterFields.createdBy, '', 'Created By'),
  new ItemPickerModel(PeopleFilterFields.createdOn, '', 'Created On'),
  new ItemPickerModel(PeopleFilterFields.activeTeamsCount, '', 'Active Teams Count'),
  new ItemPickerModel(PeopleFilterFields.allTeamsCount, '', 'All Teams Count'),
  new ItemPickerModel(PeopleFilterFields.tags, '', 'Tags'),
  new ItemPickerModel(PeopleFilterFields.notes, '', 'Notes'),
  new ItemPickerModel(PeopleFilterFields.applications, '', 'Submitted Forms'),
  new ItemPickerModel(PeopleFilterFields.activeCertifications, '', 'Active Certifications'),
  new ItemPickerModel(PeopleFilterFields.certifications, '', 'All Certifications')
];
